const Techniques = ['boil', 'roast', 'deep-fry', 'grill', 'raw', 'saute', 'steam']

export default Techniques